import { useTranslation } from "react-i18next";
import "../../../i18n";

const CITY_KEYS = ["delhi", "mumbai", "pune", "bengaluru", "hyderabad", "jaipur", "chennai"];

function ProofBar() {
  const { t } = useTranslation("marketing");

  return (
    <div className="ul-proof-bar">
      <span className="ul-proof-text">{t("proofBar.text")}</span>
      <div className="ul-proof-cities">
        {CITY_KEYS.map((c) => (
          <span className="ul-city-tag" key={c}>
            <span className="ul-city-dot" aria-hidden="true" />
            {t(`proofBar.cities.${c}`)}
          </span>
        ))}
      </div>
    </div>
  );
}

export default ProofBar;
